import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from '@mui/material';
import { auth } from '../firebase';
import { useInvoicePrintLayout } from '../hooks/useInvoicePrintLayout';
import { InvoiceHeaderWithLogo, InvoicePrintBrowserHint, PardavejasWithBankBlock, PirkėjasBlock } from './InvoiceSharedParts';

const ADMIN_UID = 'w4JeMlHRtue6uPPAZKeOgLfKJkL2';

const TEST_INVOICE = {
  serialNo: '01-0001',
  buyer: {
    name: 'Testas UAB (pavyzdys)',
    address: 'Gedimino pr. 1, LT-01103 Vilnius',
    companyCode: '123456789',
    accountNo: '',
    bank: '',
    bankCode: '',
    swift: '',
  },
  lines: [{ title: 'Teniso treniruotės', total: 40.0 }],
  issuerName: 'Elvis Gotovskis',
};

export default function ProformaInvoiceTestPage() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  useInvoicePrintLayout('Išankstinė sąskaita faktūra');

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      if (!user || user.uid !== ADMIN_UID) {
        navigate('/admin', { replace: true });
        return;
      }
      setChecking(false);
    });
    return () => unsub();
  }, [navigate]);

  if (checking) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography color="text.secondary">Kraunama...</Typography>
      </Box>
    );
  }

  const { serialNo, buyer, lines, issuerName } = TEST_INVOICE;
  const grandTotal = lines.reduce((sum, line) => sum + line.total, 0);

  return (
    <Box className="invoice-document" sx={{ minHeight: '100vh', bgcolor: 'grey.100', '@media print': { minHeight: 'auto', bgcolor: 'white' } }}>
      <AppBar position="static" color="primary" sx={{ '@media print': { display: 'none' } }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Išankstinė sąskaita faktūra - testas
          </Typography>
          <Button color="inherit" onClick={() => navigate('/admin/administracija')}>Atgal</Button>
          <Button color="inherit" onClick={() => window.print()}>Spausdinti / PDF</Button>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2, '@media print': { p: 0, bgcolor: 'white' } }}>
        <Paper sx={{ maxWidth: '210mm', mx: 'auto', p: 4, fontFamily: 'Arial, Helvetica, sans-serif' }}>
          <InvoiceHeaderWithLogo title="Išankstinė sąskaita faktūra" serialNo={serialNo} />

          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, mb: 2 }}>
            <PardavejasWithBankBlock />
            <PirkėjasBlock buyer={buyer} />
          </Box>

          <TableContainer>
            <Table size="small" sx={{ border: '1px solid', borderColor: 'divider' }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Pavadinimas</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700, width: 140 }}>Suma, Eur</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {lines.map((line, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{line.title}</TableCell>
                    <TableCell align="right">{line.total.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell align="right" sx={{ fontWeight: 700 }}>Iš viso planuojama, Eur</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700 }}>{grandTotal.toFixed(2)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 5, display: 'flex', alignItems: 'baseline', gap: 1 }}>
            <Typography variant="body1">Sąskaitą išrašė:</Typography>
            <Typography variant="body1">{issuerName}</Typography>
          </Box>
          <InvoicePrintBrowserHint />
        </Paper>
      </Box>
    </Box>
  );
}
